import { useFocus, useHover } from '@nettbureau/core';
import { useLink as useLink$1, mergeProps } from 'react-aria';

/**
 * Hook for building an accessible link.
 *
 * @param options - Options for the hook.
 * @param ref - A ref to the underlying HTML element.
 */ function useLink(options, ref) {
    const { as, disabled, ...otherOptions } = options;
    const { isPressed, linkProps } = useLink$1({
        ...otherOptions,
        elementType: as,
        isDisabled: disabled
    }, ref);
    const [{ focused, focusVisible }, { focusProps }] = useFocus({
        ...otherOptions,
        disabled
    });
    const [{ hovered }, { hoverProps }] = useHover({
        ...otherOptions,
        disabled
    });
    return [
        {
            focused,
            focusVisible,
            pressed: isPressed,
            hovered
        },
        {
            linkProps: mergeProps(focusProps, hoverProps, linkProps)
        }
    ];
}

export { useLink };
//# sourceMappingURL=use-link.js.map
